<template>
  <section class="h_77">
    <m-img src="@/v2/mobile/assets/image/h_77.jpg"></m-img>
  </section>
</template>

<script>
export default {}
</script>
<style lang="less" scoped>
.h_77 {
  margin-top: -20px;
  padding-bottom: 2.2rem;
  background: #fff;
}
</style>
